import styled from "styled-components";

export const Container = styled.section`
  margin-top: 15rem;
  padding: 2rem;
  font-family: 'Fira Code', monospace;

  .experience-section {
    max-width: 1000px;
    margin: 0 auto;

    .section-title {
      font-size: 4rem;
      font-weight: bold;
      margin-bottom: 5rem;
      text-align: center;
      color: var(--green);
    }

    .experience-list {
      display: flex;
      flex-direction: column;
    }

    .experience-item {
      display: flex;
      gap: 1rem;
      position: relative;
      padding-bottom: 4rem;

      &:last-child {
        padding-bottom: 0;
      }

      .git-indicator {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 140px;
        
        .terminal-prompt {
          color: var(--green);
          font-weight: bold;
          font-size: 1.2rem;
          white-space: nowrap;
          z-index: 1;
          background: var(--black);
          padding: 0 0.5rem;
        }
      }

      .content {
        .commit-hash {
          color: #d19a66; // Orange hash
          font-size: 1.4rem;
          margin-bottom: 0.5rem;
        }

        .job-title {
          font-size: 2.2rem;
          font-weight: bold;
          margin-bottom: 0.5rem;
          color: #FFF;
        }

        .job-duration {
          font-size: 1.4rem;
          margin-bottom: 1rem;
          color: #6a737d;
        }

        .commit-msg {
          color: var(--green);
          font-size: 1.6rem;
          margin-bottom: 1.5rem;
          &::before {
            content: "> ";
          }
        }

        .job-details {
          list-style: none;
          font-size: 1.4rem;
          line-height: 1.6;
          color: #d1d5db;

          li {
            margin-bottom: 0.8rem;
            &::before {
              content: "* ";
              color: var(--blue);
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    margin-top: 10rem;
    .experience-section .section-title {
      font-size: 3rem;
      margin-bottom: 3rem;
    }

    .experience-item {
      flex-direction: column;
      gap: 1rem;
      padding-bottom: 3rem;

      .git-indicator {
        align-items: flex-start;
        min-width: auto;
      }

      .content {
        .job-title {
          font-size: 1.8rem;
        }
        .commit-msg {
          font-size: 1.4rem;
        }
      }
    }
  }
`;
